import CornersButton from './components/CornersButton';
import CornersTag from './components/CornersTag';
import CornerTag from './components/CornerTag';

export {
  CornersButton,
  CornersTag,
  CornerTag,
};
